import { render } from "./InvoicePage1.vue?vue&type=template&id=a9d48486&scoped=true"
import script from "./InvoicePage1.vue?vue&type=script&lang=js"
export * from "./InvoicePage1.vue?vue&type=script&lang=js"

import "./InvoicePage1.vue?vue&type=style&index=0&id=a9d48486&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-a9d48486"

export default script